import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=0375960c&"
import script from "./Affiliates.ts?vue&type=script&lang=ts&"
export * from "./Affiliates.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports